export const local = {
    production: false,
    // backendUrl: 'https://workshop.millenniumzone.net/backend/api/web',
    backendUrl: 'https://workshop.aliezzeddine.net/backend/api/web',
    
  };
  